import { Flex, Text } from '@mantine/core';
import { IconUser, IconClock } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { formatDuration } from 'src/meetings/utils/date-utils';
import type { CalendarEvent } from 'src/meetings/models';
import { GuestSummary } from '../../components/GuestSummary';

type Props = {
  event: CalendarEvent;
};

export const EventInfoRow = ({ event }: Props) => {
  const duration = formatDuration(event.scheduledStartAt, event.scheduledEndAt);

  return (
    <Flex gap="lg">
      <Flex align="center" gap="xxxs">
        <IconUser size={16} />
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          <GuestSummary event={event} />
        </Text>
      </Flex>
      <Flex align="center" gap="xxxs">
        <IconClock size={16} />
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          Total meeting duration {duration}
        </Text>
      </Flex>
    </Flex>
  );
};
